import {
  getObject,
  getOptionalObject,
} from "@surya-digital/leo-ts-types";
import { Code, CodeDTO } from "./code";
import { SurveyLocalizedText, SurveyLocalizedTextDTO } from "../assets/surveyLocalizedText";

export interface SingleChoiceOptionDTO {
  code: CodeDTO;
  option?: SurveyLocalizedTextDTO | null;
}

export class SingleChoiceOption {
  readonly isSingleChoiceOptionSingleChoiceOption: boolean = true;

  readonly code: Code;
  readonly option: SurveyLocalizedText | null;


  constructor(
  code: Code, 
  option: SurveyLocalizedText | null = null
  ) {
    this.code = code;
    this.option = option;
  }

  static fromDTO(dto: SingleChoiceOptionDTO): SingleChoiceOption {
    const code = Code.fromDTO(getObject(dto, "code", InvalidSingleChoiceOptionCodeError));
    let option = getOptionalObject(dto, "option");
    if(option !== undefined && option !== null) {
      option = SurveyLocalizedText.fromDTO(getObject(dto, "option", InvalidSingleChoiceOptionOptionError));
    }
    return new SingleChoiceOption(
      code,
      option
    );
  }

  toDTO(): SingleChoiceOptionDTO {
    const dto: SingleChoiceOptionDTO = {
        code: this.code.toDTO(),
    };
    if (this.option !== undefined && this.option !== null){
      dto.option = this.option.toDTO();
    }
    return dto;
  }
  }

SingleChoiceOption.prototype.toString = function toString(): string {
  return `SingleChoiceOption(code='${this.code}',option='${this.option}')`;
};

export class InvalidSingleChoiceOptionError extends Error {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidSingleChoiceOptionError";
  }
}
export class InvalidSingleChoiceOptionCodeError extends InvalidSingleChoiceOptionError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidSingleChoiceOptionCodeError";
  }
}

export class InvalidSingleChoiceOptionOptionError extends InvalidSingleChoiceOptionError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidSingleChoiceOptionOptionError";
  }
}
